/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LastName({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/LastName"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let cardPatientLastnameValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.lastName',
})
let cardMatchLastnameValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.lastName',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="LastName.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1DJGiS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={!cardMatchLastnameValueData ? dtColorsRed900 : dtColorsNeutral900}
 data="card.patient.lastName"
 text={cardPatientLastnameValueData}
 data="card.match.lastName"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 text="•"
/>
</div>
{children}
</React.Fragment>)
}